import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { CONSENT_KEY } from "@/lib/pixels";

const WHATSAPP = "https://wa.me/33752980486";

function manageCookies() {
  try {
    localStorage.removeItem(CONSENT_KEY);
  } catch (e) {
    /* stockage indisponible */
  }
  window.location.reload();
}

export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-neutral-200 bg-white px-6 py-10 sm:px-12 lg:px-20" data-testid="site-footer">
      <div className="mx-auto grid max-w-6xl gap-8 sm:grid-cols-2 lg:grid-cols-3">
        <div>
          <Logo className="h-10" />
          <p className="mt-3 text-xs leading-relaxed text-neutral-500">
            Trouve ta place en permis accéléré dans une auto-école partenaire, gratuitement. Le prix de la formation se règle
            directement à l'auto-école.
          </p>
        </div>
        <div>
          <p className="text-xs font-bold uppercase tracking-wider text-neutral-400">Élèves</p>
          <ul className="mt-3 space-y-2 text-sm text-neutral-600">
            <li>
              <Link to="/reserver" data-testid="footer-reserver-link" className="hover:text-brand transition-colors">
                Trouver ma place en accéléré
              </Link>
            </li>
            <li>
              <Link to="/repasser-permis" data-testid="footer-retake-link" className="hover:text-brand transition-colors">
                Repasser son permis rapidement
              </Link>
            </li>
            <li>
              <a href={WHATSAPP} target="_blank" rel="noreferrer" className="hover:text-brand transition-colors">
                Nous contacter (WhatsApp)
              </a>
            </li>
            <li>
              <Link to="/bon-carburant" data-testid="footer-bon-carburant-link" className="font-semibold text-emerald-700 hover:text-emerald-600 transition-colors">
                Bon d'achat 25 €
              </Link>
            </li>
            <li>
              <Link to="/contact" data-testid="footer-contact-link" className="hover:text-brand transition-colors">
                Contact
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <p className="text-xs font-bold uppercase tracking-wider text-neutral-400">Ambassadeurs</p>
          <ul className="mt-3 space-y-2 text-sm text-neutral-600">
            <li>
              <Link to="/ambassadeur" data-testid="footer-ambassador-link" className="hover:text-brand transition-colors">
                Devenir ambassadeur
              </Link>
            </li>
            <li>
              <Link to="/ambassadeur/dashboard" data-testid="footer-ambassador-dashboard-link" className="hover:text-brand transition-colors">
                Mon tableau de bord
              </Link>
            </li>
            <li>
              <Link to="/conditions-recompenses" data-testid="footer-conditions-link" className="hover:text-brand transition-colors">
                Conditions des récompenses
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <p className="text-xs font-bold uppercase tracking-wider text-neutral-400">Guides & blog</p>
          <ul className="mt-3 space-y-2 text-sm text-neutral-600">
            <li>
              <Link to="/blog" data-testid="footer-blog-link" className="hover:text-brand transition-colors">
                Tous les guides
              </Link>
            </li>
            <li>
              <Link to="/blog/cpf-permis-conduire-2026" data-testid="footer-blog-cpf" className="hover:text-brand transition-colors">
                CPF et permis de conduire
              </Link>
            </li>
            <li>
              <Link to="/blog/financement-permis-b-aides-2026" data-testid="footer-blog-financement" className="hover:text-brand transition-colors">
                Financer son permis B
              </Link>
            </li>
            <li>
              <Link to="/blog/budget-permis-conduire-2026" data-testid="footer-blog-budget" className="hover:text-brand transition-colors">
                Budget du permis 2026
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <p className="text-xs font-bold uppercase tracking-wider text-neutral-400">Auto-écoles</p>
          <ul className="mt-3 space-y-2 text-sm text-neutral-600">
            <li>
              <Link to="/inscription-auto-ecole" data-testid="footer-register-link" className="hover:text-brand transition-colors">
                Devenir partenaire
              </Link>
            </li>
            <li>
              <Link to="/connexion" data-testid="footer-login-link" className="hover:text-brand transition-colors">
                Espace partenaires
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <p className="text-xs font-bold uppercase tracking-wider text-neutral-400">Informations légales</p>
          <ul className="mt-3 space-y-2 text-sm text-neutral-600">
            <li>
              <Link to="/qui-sommes-nous" data-testid="footer-about-link" className="hover:text-brand transition-colors">
                Qui sommes-nous ?
              </Link>
            </li>
            <li>
              <Link to="/cgu" data-testid="footer-cgu-link" className="hover:text-brand transition-colors">
                Conditions Générales d'Utilisation
              </Link>
            </li>
            <li>
              <Link to="/cgv" data-testid="footer-cgv-link" className="hover:text-brand transition-colors">
                Conditions Générales de Vente
              </Link>
            </li>
            <li>
              <Link to="/confidentialite" data-testid="footer-privacy-link" className="hover:text-brand transition-colors">
                Politique de confidentialité
              </Link>
            </li>
            <li>
              <Link to="/mentions-legales" data-testid="footer-legal-link" className="hover:text-brand transition-colors">
                Mentions légales
              </Link>
            </li>
            <li>
              <button
                type="button"
                onClick={manageCookies}
                data-testid="footer-cookies-link"
                className="text-left hover:text-brand transition-colors"
              >
                Gérer mes cookies
              </button>
            </li>
          </ul>
        </div>
      </div>
      <div className="mx-auto mt-8 max-w-6xl border-t border-neutral-100 pt-6 text-xs text-neutral-400">
        © {year} PlanPermis · Tous droits réservés
      </div>
    </footer>
  );
}

export default Footer;
